import { render } from "./ShopDetail.vue?vue&type=template&id=d905446a&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"

import "./ShopDetail.vue?vue&type=style&index=0&id=d905446a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d905446a"]])

export default __exports__